// ─── Save guard, browser leave-confirmation while data is being saved ───────
// Every in-flight write registers here; while at least one is active (or a
// flow holding unsaved work, like an open logo-crop modal, has pinned the
// guard), reloading or closing the tab raises the browser's native "are you
// sure?" dialog so a save isn't silently cut short. Browsers show their own
// generic wording, the message text can't be customized.

let active = 0;

if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', (e) => {
        if (active > 0) {
            e.preventDefault();
            e.returnValue = '';   // legacy engines require a set returnValue
        }
    });
}

export function beginSave() { active += 1; }
export function endSave() { active = Math.max(0, active - 1); }

// Wrap a write's promise: guarded from call until settle (success or failure).
export function guardSave(promise) {
    beginSave();
    return Promise.resolve(promise).finally(endSave);
}

// Test seam.
export function _activeCount() { return active; }
